<template>
  <component :is="component" />
</template>

<script>
import salePlanCheck from '../components/salePlanCheck.vue'
import salePlanEdit from '../salePlanEdit.vue'
export default {
  components: {
    salePlanCheck,
    salePlanEdit
  },
  data() {
    return {
      component: 'salePlanCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'salePlanCheck' : 'salePlanEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/check/salePlanCheck.vue